import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { ActionMenuItem } from './ActionMenuItem';
import { AlsActivityStatus } from 'src/graphql/generated';
import { AuthContext, AuthContextType } from 'src/contexts/AuthContext';

export const AlsActions = ({ activity }: ActivityActionsProps) => {
  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');
  const { canImpersonate } = useContext(AuthContext) as AuthContextType;
  const statusReturned = activity?.status === AlsActivityStatus?.AlsReturned;
  const statusDraft = activity?.status === AlsActivityStatus?.AlsDraft;
  return (
    <>
      <NavLink to={'/als/' + activitykeyUrlEncoded}>
        {canImpersonate ? (
          statusDraft || statusReturned ? (
            <ActionMenuItem icon={'edit'} title={'Edit'} />
          ) : (
            <ActionMenuItem icon={'view'} title={'View'} />
          )
        ) : statusDraft || statusReturned ? (
          <ActionMenuItem icon={'edit'} title={'Edit'} />
        ) : (
          <ActionMenuItem icon={'view'} title={'View'} />
        )}
      </NavLink>
    </>
  );
};
